import {AbstractAcStandardMapper} from "../abstract-ac-standard.mapper";

export class FrAcSasSynthesisMapper extends AbstractAcStandardMapper {
}
